module.exports = __webpack_public_path__ + "static/handheld_scanner-5771ea170011588905ddce02524d73ed.jpg";